import api from '../../plugins/api';

const createCar = (params) => {
  return api.post('/api/crm/cars/createCar', params, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export default createCar;
